import { render, staticRenderFns } from "./LeftPosition.vue?vue&type=template&id=02524c72&scoped=true"
import script from "./LeftPosition.vue?vue&type=script&lang=js"
export * from "./LeftPosition.vue?vue&type=script&lang=js"
import style0 from "./LeftPosition.vue?vue&type=style&index=0&id=02524c72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02524c72",
  null
  
)

export default component.exports